import { useTranslation } from 'react-i18next';

import { PaymentProviderConnectionCard } from '@/components/payments/payment-provider-connection-card';
import { PageHeader } from '@/components/shared/page-header';
import { Card, CardContent } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { useElevateSession } from '@/hooks/use-elevate-session';
import { useOnlineGivingSetup } from '@/lib/payment-providers';

export const OnlineGivingSettingsPage = () => {
  const { t } = useTranslation('payments');
  const { providers, connectionByProvider, isLoading, isError, refetch } = useOnlineGivingSetup();
  const { dialog: sessionDialogs } = useElevateSession();

  const multipleProviders = providers.length > 1;

  return (
    <div>
      <PageHeader title={t('onlineGiving.title')} description={t('onlineGiving.description')} />

      {isLoading ? (
        <div className="mt-6 grid gap-6 lg:grid-cols-2">
          <Skeleton className="h-64 rounded-lg" />
          {multipleProviders ? <Skeleton className="h-64 rounded-lg" /> : null}
        </div>
      ) : isError ? (
        <Card className="mt-6">
          <CardContent className="py-8 text-center text-body text-fg-secondary">
            {t('onlineGiving.loadError')}
          </CardContent>
        </Card>
      ) : providers.length === 0 ? (
        <Card className="mt-6">
          <CardContent className="py-8 text-center text-body text-fg-secondary">
            {t('onlineGiving.noneAvailable')}
          </CardContent>
        </Card>
      ) : (
        <div className="mt-6 space-y-4">
          {multipleProviders ? (
            <p className="text-body-sm text-fg-secondary">{t('onlineGiving.chooseProvider')}</p>
          ) : null}

          <div
            className={
              multipleProviders ? 'grid gap-6 lg:grid-cols-2 lg:items-start' : undefined
            }
          >
            {providers.map((provider) => (
              <PaymentProviderConnectionCard
                key={provider.key}
                provider={provider}
                connection={connectionByProvider.get(provider.key) ?? null}
                onUpdated={() => void refetch()}
              />
            ))}
          </div>
        </div>
      )}

      <p className="mt-6 text-body-sm text-fg-muted">{t('onlineGiving.footerNote')}</p>

      {sessionDialogs}
    </div>
  );
};
